import { render, staticRenderFns } from "./WalletSessionItemCard.vue?vue&type=template&id=bfbfc0d6&scoped=true&"
import script from "./WalletSessionItemCard.vue?vue&type=script&lang=js&"
export * from "./WalletSessionItemCard.vue?vue&type=script&lang=js&"
import style0 from "./WalletSessionItemCard.vue?vue&type=style&index=0&id=bfbfc0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbfc0d6",
  null
  
)

export default component.exports